// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resize-bar{display:flex;align-items:center;justify-content:center;cursor:col-resize;width:14px;background-color:var(--panel-background);border-right:1px solid var(--lighter-border);border-left:1px solid var(--lighter-border);z-index:65}.resize-bar[data-element=stylePanelResizeBar]{border-color:var(--lighter-border)}", ""]);
// Exports
module.exports = exports;
